import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';
import { toasterMsg } from '../Components/Toaster/Toaster';

export const getProductTesting = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_TESTING.GET_ALL_TESTINGS}/${data.id}`, {
      params: { ...data },
    });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const getAllTestingAttri = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.TESTING.TESTING_REPORTS}`, {
      params: { ...data },
    });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const getAllProductTestingAttri = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.TESTING.GET_TESTING_ATTRIBUTES}`, {
      params: { ...data },
    });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const UploadTestingReport = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.TESTING.TESTING_REPORTS}`, data);
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const getBomForProductTesting = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_TESTING.GET_ALL_BOM_LIST}`, {
      params: { ...data },
    });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const getAllLibList = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_TESTING.GET_ALL_LIB_LIST}`, {
      params: { ...data },
    });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const getAllGroupList = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_TESTING.GET_ALL_GROUP_LIST}`, {
      params: { ...data },
    });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const getFilteredTestReport = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_TESTING.GET_FILTEREDREPORTS}`, {
      params: { ...data },
    });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const getAllProductList = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_TESTING.GET_ALL_PRODUCT_LIST}`, {
      params: { ...data },
    });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const getAllProducts = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_TESTING.GET_ALL_PRODUCTS}/${data.id}`);
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const getAllProductRefs = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_TESTING.GET_ALL_PRODUCT_REFS}`);
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const getAllProductRefsForBom = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_TESTING.GET_ALL_PRODUCT_FOR_BOM}/${data.bomComponentId}`);
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const getAllproductReports = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_TESTING.GET_REPORTS}/${data?.id}`, {
      params: { ...data },
    });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const updateTestReports = async (data, id) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PRODUCT_TESTING.GET_REPORTS}/${data.devOrderId}`, { ...data }, { params: { testReportId: id } });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const getArchiveReport = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_TESTING.GET_ARCHIVE_REPORT}/${data.devOrderId}`, {
      params: { ...data },
    });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const getColoursForProductTesting = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_TESTING.GET_ALL_COLOUR_LIST}`, {
      params: { ...data },
    });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const getTestReportProductTesting = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_TESTING.GET_ALL_TEST_REPORT}`, {
      params: { ...data },
    });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const updateTestRequirmentProductTesting = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PRODUCT_TESTING.GET_ALL_TEST_REPORT}`, { ...data });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const getTheComment = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_TESTING.POST_TEST_COMMENT}`, {
      params: { ...data },
    });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const delteTheComment = async (data, id) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PRODUCT_TESTING.GET_ALL_TESTINGS}/${id}/status`, {
      ...data,
    });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const delteTestReports = async (data, id, comId) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.PRODUCT_TESTING.DELETE_REPORTS_TESTING}/${id}/${comId}`, {
      ...data,
    });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const delteTestsFromProduct = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.PRODUCT_TESTING.ORDER_TESTING_FROM_PRODUCT}`, {
      data: { ...data },
    });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const postTestsFromProduct = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_TESTING.ORDER_TESTING_FROM_PRODUCT}`, { ...data });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const putTestsFromProduct = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PRODUCT_TESTING.ORDER_TESTING_FROM_PRODUCT}`, { ...data });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const delteTestRequirments = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.PRODUCT_TESTING.GET_ALL_TEST_REPORT}`, {
      data: { ...data },
    });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const getSpecificTestReport = async (data, id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_TESTING.POST_REPORTS}/${id}`, {
      params: { ...data },
    });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const sendTestingToLibrary = async (data, id) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_TESTING.POST_TO_LIBRARY}`, { ...data }, { params: { devOrderId: id } });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const addProductToLibrary = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_TESTING.GET_ALL_TESTINGS}/${data.devOrderId}`, { ...data });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const PostFromAttribute = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_TESTING.POST_FROM_TEST_ATTRI}`, { ...data });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const addColorLibrary = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_TESTING.POST_TO_LIBRARY_TEST}/${data.devOrderId}`, { ...data });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const postFromBom = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_TESTING.POST_FROM_BOM}`, { ...data });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const addTestingReports = async (data, id) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_TESTING.POST_REPORTS}/${id}`, data);
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const uploadingTestingReports = async (data, id, type) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_TESTING.POST_TESTING_REPORT}/${type}/${id}`, data);
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const RenewTestingReports = async (data, id) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_TESTING.RENEW_TESTING_REPORT}/${id}`, data);
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const addProductTesting = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_TESTING.POST_TO_LIBRARY_TEST}`, { ...data });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const sendTestingToProduct = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_TESTING.POST_TO_LIBRARY_TEST}/${data.devOrderId}/previous-style`, { ...data });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const PostTestComment = async (data, id) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_TESTING.POST_TEST_COMMENT}`, { ...data }, { params: { ...id } });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const ApproveRejectComment = async (data, id) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_TESTING.GET_ALL_TESTINGS}/${id}/status`, {
      ...data,
    });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const addColorGroup = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_TESTING.POST_TO_GROUP_TEST}`, {
      ...data,
    });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const editTest = async (data, id) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PRODUCT_TESTING.GET_ALL_TESTINGS}/${id}`, {
      ...data,
    });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const edit_Sequence = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PRODUCT_TESTING.SAVE_SEQUENCE}/${data.devOederId}`, {
      ...data,
    });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const deleteProductTests = async (data) => {
  try {
    // data.testLibIds && data.testLibIds.length !== 1?
    // `${apiEndpoint}${API.PRODUCT_TESTING.GET_ALL_TESTINGS}/${data.multiDelId}`,
    return await apiClient.delete(`${apiEndpoint}${API.PRODUCT_TESTING.GET_ALL_TESTINGS}`, {
      data: { ...data },
    });
    // : await apiClient.delete(
    //     `${apiEndpoint}${API.PRODUCT_TESTING.GET_ALL_TESTINGS}`,
    //     // `${apiEndpoint}${API.PRODUCT_TESTING.GET_ALL_TESTINGS}/${data.id}`,
    //     {
    //       data: {
    //         devOrderId: data.devOrderId,
    //         testLibIds: data.testLibIds,
    //       },
    //     }
    //   );
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const addDesignDetails = async (id, data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DESIGN_DETAILS.FIRST_PART}/${id}${API.DESIGN_DETAILS.ADD_DESIGN_DETAIL}`, { ...data });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const postPermissionForDesignDetails = async (id, data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DESIGN_DETAILS.PERMISSIONS}`, { ...data }, { params: { ...id } });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const markCompletion = async (id, data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DESIGN_DETAILS.COMPLETION}/${id}/design`, null, { params: { ...data } });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const fetchDesignDetailsPermission = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DESIGN_DETAILS.PERMISSIONS}`, { params: { ...id } });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const duplicateSamples = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DESIGN_DETAILS.FIRST_PART}/${API.DESIGN_DETAILS.DUPLICATE_DESIGN}`, { ...data });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};
export const replaceSamples = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DESIGN_DETAILS.FIRST_PART}/${API.DESIGN_DETAILS.REPLACE_DESIGN}`, { ...data });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

// service for save cropped default image
export const cropDefaultSamples = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DESIGN_DETAILS.FIRST_PART}/${API.DESIGN_DETAILS.CROP_DEFAULT_DESIGN}`, { ...data });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const archiveSample = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DESIGN_DETAILS.FIRST_PART}/${API.DESIGN_DETAILS.ARCHIVE_REPORT}`, { ...data });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const appRejSample = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DESIGN_DETAILS.FIRST_PART}/${API.DESIGN_DETAILS.APPROVE_REJECT_DESIGN}`, { ...data });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const removeSampleDesign = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DESIGN_DETAILS.FIRST_PART}/${API.DESIGN_DETAILS.REMOVE_DESIGN_STATUS}`, { ...data });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const getDocumentList = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DESIGN_DETAILS.GET_DOCUMENT_LIST}`, { params: { ...data } });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const fetchDesignDetails = async (id, data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DESIGN_DETAILS.FIRST_PART}/${id}${API.DESIGN_DETAILS.ADD_DESIGN_DETAIL}`, { params: { ...data } });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const getmanualDocList = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.DESIGN_DETAILS.GET_MANUAL_DOCUMENT_LIST}`, { params: { ...data } });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const getMultiProductTestingLibs = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_TESTING.GET_ALL_TESTINGS_MULTI_PRODUCT}`, { ...data });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const clearHighlight = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_TESTING.CLEAR_HIGHLIGHT}`, {
      ...data,
    });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
    return null;
  }
};

export const addSingleDesignDetails = async (id, data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.DESIGN_DETAILS.FIRST_PART}/${id}${API.DESIGN_DETAILS.SINGLE_TITLE_SAVE}`, { ...data });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
  }
};
